<template lang="pug">
.vprStartworkPlayerComponent
  vpr-player-background( :subject="subject" )
  .vprContent(ref="iframeWrapperRef")
    iframe.iframe(
      :src="vpr.startwork.iframeUrl"
      loading="lazy"
      ref="iframeRef"
      :style="iframeStyle"
    )
</template>

<script>
import { computed, inject, onUnmounted, ref, watch } from 'vue'
import clamp from '@/_core/helpers/clamp'
import VprPlayerBackground from '../VprPlayerBackground'
import PlayerModalClose from '@/components/Player/PlayerModalClose/PlayerModalClose'
import PlayerVprController from '@/controllers/ChildVpr/PlayerVprController'
import router from '@/router'

export default {
  components: {
    VprPlayerBackground,
    PlayerModalClose
  },
  setup () {
    const store = inject('store')
    const controller = inject('controller')

    const iframeRef = ref(null)
    const iframeWrapperRef = ref(null)

    // Iframe scaling.
    const IFRAME_WIDTH = 900
    const IFRAME_HEIGHT = 800

    const calculateScaleModifier = () => {
      if (!iframeRef.value || !iframeWrapperRef.value) return false

      const wrapperWidth = iframeWrapperRef.value.offsetWidth
      const wrapperHeight = iframeWrapperRef.value.offsetHeight

      const scaleX = wrapperWidth / IFRAME_WIDTH
      const scaleY = wrapperHeight / IFRAME_HEIGHT

      const scale = clamp(Math.min(scaleX, scaleY), 0, 1)

      cssScale.value = scale
    }

    const cssScale = ref(1)

    const iframeStyle = computed(() => {
      return {
        transform: `scale(${cssScale.value})`,
        width: `calc(100% / ${cssScale.value})`,
        height: `calc(100% / ${cssScale.value})`
      }
    })

    window.addEventListener('resize', calculateScaleModifier)

    watch(iframeRef, calculateScaleModifier)

    const { initIframeListener, destroyIframeListener, $on, $off } = PlayerVprController(controller)

    setTimeout(() => { initIframeListener(iframeRef.value) }, 0)

    const showCloseModal = () => {
      store.modalQueue.push({
        key: 'vprclose',
        component: PlayerModalClose,
        params: {
          isClosable: false
        },
        props: {
          title: 'Вы уверены, что хотите выйти?'
        },
        on: {
          submit: onCloseSubmit
        }
      })
    }

    const onCloseSubmit = () => router.push({ name: 'VprContents' })

    $on('iframe-close-click', showCloseModal)

    onUnmounted(() => {
      destroyIframeListener()
      $off('iframe-close-click', showCloseModal)
      window.removeEventListener('resize', calculateScaleModifier)
    })

    return {
      iframeRef,
      iframeWrapperRef,
      iframeStyle,
      vpr: computed(() => controller.childVpr.value.userItem.vpr),
      subject: computed(() => controller.childVpr.value.userItem.vpr.subject)
    }
  }
}
</script>

<style lang="sass" scoped>
.vprStartworkPlayerComponent
  position: fixed
  width: 100vw
  height: 100%
  top: 0
  left: 0
  background-color: $cBackground
  z-index: $zIndexPlayerIframe
  display: flex
  align-items: center
  justify-content: center

  > .vprContent
    width: 100%
    height: 100%
    max-width: 1100px
    max-height: 700px
    border-radius: $brXXL
    background-color: $cWhite
    padding: 5*$u

    > .iframe
      width: 900px
      height: 800px
      display: block
      transform-origin: top left
</style>
